var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order_history",
    "data-name": "order history",
    transform: "translate(-166.293 -383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-989.707 328)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    width: 22,
    height: 22,
    transform: "translate(1156 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-search",
    "data-name": "Icon feather-search",
    transform: "translate(1154.5 53.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38059",
    "data-name": "Path 38059",
    d: "M11.457,3.85v0A7.607,7.607,0,1,1,3.85,11.457,7.558,7.558,0,0,1,11.457,3.85Zm0,13.915a6.307,6.307,0,1,0,0-12.615h0a6.307,6.307,0,1,0,0,12.615Z",
    transform: "translate(0 0)",
    fill: "#4c3cee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38060",
    "data-name": "Path 38060",
    d: "M28.3,29.218l-3.783-3.783.919-.919L29.218,28.3Z",
    transform: "translate(-7.604 -7.604)",
    fill: "#4c3cee"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173888",
    "data-name": "Group 173888",
    transform: "translate(-2 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_494",
    "data-name": "Line 494",
    d: "M.5,4h-1V0h1Z",
    transform: "translate(175.5 374.5)",
    fill: "#4c3cee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_495",
    "data-name": "Line 495",
    d: "M.5,4h-1V0h1Z",
    transform: "translate(177.293 374.5)",
    fill: "#4c3cee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_496",
    "data-name": "Line 496",
    d: "M.5,4h-1V0h1Z",
    transform: "translate(179.086 374.5)",
    fill: "#4c3cee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_497",
    "data-name": "Line 497",
    d: "M.5,4h-1V0h1Z",
    transform: "translate(180.879 374.5)",
    fill: "#4c3cee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.0339afa2a012afeae43aafcda41f91f1.svg";
export { ForwardRef as ReactComponent };